import { render, staticRenderFns } from "./picker-article.vue?vue&type=template&id=8ccabcc8"
import script from "./picker-article.vue?vue&type=script&lang=js"
export * from "./picker-article.vue?vue&type=script&lang=js"
import style0 from "./picker-article.vue?vue&type=style&index=0&id=8ccabcc8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports